<template>
  <v-form>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-alert
          type="error"
          class="mt-4 mb-2"
          dismissible
          :value="error"
          @input="error = arguments[0] ? error : null"
        >
          {{ error }}
        </v-alert>

        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                ref="name"
                v-model="model.name"
                v-validate="'required'"
                data-vv-name="name"
                :error-messages="errors.collect('name')"
                label="Name"
                required
                autocomplete="off"
              />
            </v-flex>
            <v-flex xs12>
              <UserPicker
                label="Users"
                :model-value="model.users"
                @update:modelValue="handleUsersChange"
              />
            </v-flex>
            <v-flex xs12 lg4>
              <v-switch
                color="red"
                v-model="model.archived"
                label="Archived"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions style="background-color: inherit;">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="cancel">Cancel</v-btn>
        <v-btn
          type="submit"
          color="blue darken-1"
          flat
          :loading="saving"
          @click.prevent.native="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import api from '../api'
import UserPicker from './UserPicker.vue'
import { normalizeToIriString } from '../helper/iri'
import { mapValues } from 'lodash'

const DEFAULT_MODEL = {
  id: -1,
  name: '',
  users: [],
  archived: false,
}

export default {
  components: {
    UserPicker,
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: Object,
  },

  data() {
    return {
      model: { ...DEFAULT_MODEL },
      saving: false,
      error: null,
    }
  },

  computed: {
    isNewItem() {
      return !('id' in this.model) || this.model.id === -1
    },

    formTitle() {
      return this.isNewItem ? 'New Client' : 'Edit Client'
    },
  },

  watch: {
    dialog(opened) {
      opened || this.close()

      this.$validator.reset()

      if (opened) {
        this.$nextTick(() => {
          this.$refs.name.focus()
        })
      }
    },
  },

  methods: {
    handleUsersChange(value) {
      this.model.users = normalizeToIriString(value)
    },

    cancel() {
      this.$validator.reset()
      this.$emit('update:modelValue', false)
    },

    async save() {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }

      this.saving = true

      api.endpoints.clients[this.model.id > 0 ? 'update' : 'create'](
        mapValues(
          this.model,
          (value, key) => {
            if (key === 'users') {
              return value ? normalizeToIriString(value) : null
            }
            return value
          }
        ),
        { handleValidationErrors: false }
      )
        .then(response => {
          this.model.id = response.data.id
          this.$emit('update:modelValue', this.model)
        })
        .catch(error => {
          if (error.response.status === 400 || error.response.status === 422) {
            this.error = error.response.data['hydra:description']
          }
        })
        .then(() => {
          this.saving = false
        })
    },
  },

  created() {
    this.model = Object.assign({}, this.model, this.modelValue ? this.modelValue : {})
  },
}
</script>
